import { createCustomEnum } from "./customEnum";

export type AchSourceOfDataTypeKeys = "evolve" | "esquire";

export const AchSourceOfData = createCustomEnum({
	Evolve: { value: "evolve", name: "evolve", displayName: "Evolve" },
	Esquire: { value: "esquire", name: "esquire", displayName: "Esquire" },
});
